import styled, {css} from 'styled-components'
import {StyledTableBodyCell} from '@/components/ui/table-atoms/style'

export const StyledWrapper = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        background-color: ${palette.neutral.white};
        height: 100%;
        border-radius: 0 0 8px 8px;
        border: 1px solid ${palette.neutral[200]};
        border-top: none;

        ${StyledTableBodyCell} {
            height: auto;
            min-height: ${spacing * 16}px;
        }
    `
)

export const StyledCreatedAtCell = styled.div(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;

        & > strong {
            ${typography.textSm};
            font-weight: 400;
            color: ${palette.neutral[900]};
        }

        & > span {
            ${typography.textXs};
            color: ${palette.neutral[600]};
        }
    `
)
